import { useSelector } from 'react-redux';

export default function useLoggedInUser() {
  return useSelector((state) => state.login?.user);
}
